import { useMutation, useQuery } from '@tanstack/react-query';
import fitStudioRequest from '../utils/request';

const fitMemberToPartnerServices = {
  useQueryGetMemberRequestToPartner(
    { search_text, change_sponsor, member_status, page, take, request_status },
    onSuccess
  ) {
    return useQuery(
      [
        'get-member-request-to-partner-request',
        {
          search_text,
          change_sponsor,
          member_status,
          page,
          take,
          request_status,
        },
      ],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/member-request-to-partner`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              ...(queryKey[1].search_text && {
                search_text: queryKey[1].search_text,
              }),
              ...(queryKey[1].member_status && {
                member_status: queryKey[1].member_status,
              }),
              ...(queryKey[1].request_status && {
                request_status: queryKey[1].request_status,
              }),
              ...(typeof queryKey[1].change_sponsor === 'boolean' && {
                change_sponsor: queryKey[1].change_sponsor,
              }),
            },
          });

          if (res.status === 200) {
            return res.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        refetchOnWindowFocus: false,
      }
    );
  },
  useQueryGetMemberRequestToPartnerById(
    { memberRequestToPartnerId },
    onSuccess
  ) {
    return useQuery(
      ['get-member-request-to-partner-by-id', { memberRequestToPartnerId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/member-request-to-partner/${queryKey[1].memberRequestToPartnerId}`
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!memberRequestToPartnerId,
        refetchOnWindowFocus: false,
      }
    );
  },
  useMutationUpdateMemberRequestToPartner(onSuccess) {
    return useMutation(
      async ({ id, data }) => {
        try {
          const res = await fitStudioRequest.patch(
            `/member-request-to-partner/${id}`,
            data
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationDownloadMemberRequestToPartnerListsExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/member-request-to-partner/download-excel/by-filter`,
            {
              params: {
                take: data.take,
                page: data.page,
                ...(data.search_text && {
                  search_text: data.search_text,
                }),
                ...(data.member_status && {
                  member_status: data.member_status,
                }),
                ...(data.request_status && {
                  request_status: data.request_status,
                }),
                ...(typeof data.change_sponsor === 'boolean' && {
                  change_sponsor: data.change_sponsor,
                }),
              },
              responseType: 'blob',
            }
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute(
              'download',
              'member-request-to-partner-list.xlsx'
            ); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
};

export default fitMemberToPartnerServices;
